// extracted by mini-css-extract-plugin
module.exports = {"box":"style_box__1w4sh","content":"style_content__1tMK7","text":"style_text__2RqFU"};